(() => {
  const organize = (root = document) => {
    root.querySelectorAll('.kde-organize-description:not([data-kde-organized]), .kde-organize-description section:not([data-kde-organized]), .kde-organize-description > div:not([data-kde-organized])').forEach(description => {
      description.dataset.kdeOrganized = 'true';
      const children = Array.from(description.childNodes);
      const headingCount = children.filter(node => node.nodeType === 1 && /^(H2|H3)$/.test(node.tagName)).length;
      if (headingCount < 2) return;
      let content = null;
      for (const node of children) {
        if (node.nodeType === 1 && /^(H2|H3)$/.test(node.tagName)) {
          const group = document.createElement('details');
          group.className = 'kde-description-group';
          const summary = document.createElement('summary');
          description.insertBefore(group, node);
          summary.append(node);
          group.append(summary);
          content = document.createElement('div');
          group.append(content);
        } else if (content) content.append(node);
      }
      const overview = description.querySelector('.kde-description-group');
      if (overview) overview.open = true;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => organize());
  else organize();
  document.addEventListener('shopify:section:load', event => organize(event.target));
})();

(() => {
  if (!customElements.get('kde-parts-finder')) customElements.define('kde-parts-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.querySelector('select').addEventListener('change', event => {
        this.querySelectorAll('[data-model]').forEach(panel => { panel.hidden = panel.dataset.model !== event.target.value; });
      });
    }
  });
  const initialize = () => {
    document.querySelectorAll('.kde-gallery-fit').forEach(gallery => {
      const section = gallery.closest('.section');
      section?.querySelectorAll('.kde-organize-description .kde-dimensions').forEach(duplicate => duplicate.remove());
    });
    document.querySelectorAll('.sticky-cta:not(.kde-sticky-managed)').forEach(bar => {
      const product = bar.closest('product-info');
      const button = product?.querySelector('product-form .product-form__submit');
      if (!button) return;
      bar.classList.add('kde-sticky-managed');
      const observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        bar.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
      });
      observer.observe(button);
      bar.addEventListener('click', event => {
        if (!event.target.closest('button')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const primary = product.querySelector('product-form .product-form__submit');
        if (primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') primary.click();
      }, true);
      product.querySelectorAll('variant-selects input, variant-selects select').forEach(input => input.addEventListener('change', () => {
        const stickyButton = bar.querySelector('button');
        if (stickyButton) stickyButton.disabled = true;
      }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
(() => {
  if (customElements.get('kde-catalog-filters')) return;
  customElements.define('kde-catalog-filters', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const capacity = this.querySelector('[data-kde-tag="capacity"]');
      if (capacity) [...capacity.options].slice(1).sort((a,b) => parseInt(a.text)-parseInt(b.text)).forEach(option => capacity.append(option));
      const navigate = (clear = false) => {
        const tags = (this.dataset.tags || '').split(',').filter(tag => tag && !tag.startsWith('kde-capacity-') && !tag.startsWith('kde-placement-'));
        if (!clear) this.querySelectorAll('select').forEach(select => { if (select.value) tags.push(select.value); });
        const url = new URL(this.dataset.url + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : ''), location.origin);
        url.search = location.search;
        url.searchParams.delete('page');
        location.assign(url.toString());
      };
      this.querySelector('form').addEventListener('submit', event => { event.preventDefault(); navigate(); });
      this.querySelector('[data-kde-clear]').addEventListener('click', event => { event.preventDefault(); navigate(true); });
    }
  });
})();
